module.exports = __webpack_public_path__ + "img/benefit-icon_phone.351adbf9.svg";